<div class="login-inside-container" id="div_login-inside-container_657850f3">
  <h1
    aria-label="Forgot your password"
    title="Forgot your password"
    id="h1_e54b398b"
  >
    Forgot your password?
  </h1>
  <form [formGroup]="frmForgotPassword" id="form_9da0a75e">
    <label id="label_6f695845"
      >Please enter the email address associated with your account. We’ll email
      a verification code.</label
    >
    <span
      class="p-float-label"
      style="margin-top: 43px"
      id="span_p-float-label_f932c1da"
    >
      <input
        id="email"
        type="email"
        pInputText=""
        name="email"
        formControlName="email"
      />
      <label for="email" id="label_39cc5cff">Email</label>
    </span>
    <small
      class="p-error block"
      *ngIf="frmForgotPassword.controls['email'].hasError('pattern')"
      id="small_p-error_197df107"
      >Please enter a valid email address.</small
    >
    <div class="btn-panel" id="div_btn-panel_477b6026">
      <button
        class="back-button"
        (click)="back()"
        id="button_back-button_802002a5"
      >
        <i class="pi pi-angle-left" id="i_pi_3aaf16ff"></i>
      </button>
      <button
        class="next-button"
        (click)="checkEmail()"
        [disabled]="!frmForgotPassword.controls['email'].valid"
        id="button_next-button_a9e1f6be"
      >
        NEXT
      </button>
    </div>
  </form>
</div>
<div
  class="progress-spinner"
  *ngIf="loading"
  id="div_progress-spinner_42f42170"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    id="p-progressSpinner_21d049e3"
  ></p-progressSpinner>
</div>
